import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import {Card, Divider, Link } from '@mui/material';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';

const JobPostings = (): JSX.Element => {

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            Career Opportunities
        </Typography>
        <Divider/>
        <Grid container marginTop={3}>
            <Grid 
              padding={3}
              size={12}
              component={Card}
              boxShadow={1}
              >
              <Typography variant='subtitle1'>There are no job openings at this time. Please check back later. </Typography>
            </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default JobPostings;